export const signingProviderDisplayName = (value?: string | null) => {
  const provider = value?.trim();
  switch (provider?.toLowerCase()) {
    case 'scrive':
      return 'Scrive';
    case 'zigned':
      return 'Zigned';
    case 'mock_scrive':
      return 'Mock Scrive';
    default:
      return provider || null;
  }
};
